import {LargeLanguageModel} from "../../utils/types/AiTypes";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {API_AI_LLM_LIST_ENDPOINT} from "../../utils/constants";

export interface AiLargeLanguageModelState {
    largeLanguageModels: LargeLanguageModel[];
    status: "fulfilled" | "pending" | "rejected" | "idle";
}

const initialState: AiLargeLanguageModelState = {
    largeLanguageModels: [],
    status: "idle"
}

export const fetchAllLargeLanguageModels = createAsyncThunk(
    "llm/fetchAllLLMs",
    async (params: {keycloak: Keycloak.KeycloakInstance, modelType?: string, packageId?: number, page?: number, size?: number}): Promise<LargeLanguageModel[]> => {
        const {keycloak, modelType, packageId, page, size} = params;
        const res = await axios.get(`${API_AI_LLM_LIST_ENDPOINT}`, {
            params: {
                modelType: modelType,
                packageId: packageId,
                page: page,
                size: size,
            },
            headers: {
                "Content-Type": "application/json",
                accept: "application/json",
                Authorization: `Bearer ${keycloak?.token}`,
            },
            withCredentials: true,
        });
        return res.data;
    }
);

export const AiLargeLanguageModelSlice = createSlice({
    name: 'largeLanguageModels',
    initialState,
    reducers: {
        getLargeLanguageModels: (state, action) => {
            state.status = 'fulfilled';
            state.largeLanguageModels = action.payload.data;
        },
        failedToGetLargeLanguageModels: (state) => {
            state.status = 'rejected';
            state = initialState
        },
        resetLargeLanguageModelsState: (state) => {
            state = initialState;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAllLargeLanguageModels.fulfilled, (state, action) => {
            state.status = "fulfilled";
            state.largeLanguageModels = action.payload;
        })
    }
});

export const { getLargeLanguageModels, failedToGetLargeLanguageModels,resetLargeLanguageModelsState} = AiLargeLanguageModelSlice.actions;
export default AiLargeLanguageModelSlice.reducer;